<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Local de atendimento"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :disabled="editing"
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="editing"
                        :options="data.form.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox-group
                        :validations="validations.modulo"
                        label="Módulos"
                        v-model="model.modulos"
                    >
                        <rkm-row>
                            <rkm-col
                                v-for="modulo in data.form.modulos"
                                :key="modulo.id"
                                cols="4"
                            >
                                <rkm-form-checkbox :value="modulo.id">{{modulo.nome}}</rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    
        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="include"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                modulo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('painelSenha.parametrizacao'),
        }
    },
    data: () => ({
        editing: false,
        model: {
            unidadeId: null,
            infraestruturaId: null,
            modulos: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        create() {
            this.resetForm()
            this.$refs.RkmModal.show()
        },
        edit(item) {
            this.resetForm()

            this.editing = true

            this.data.form.infraestruturas = [{id: item.id, nome: item.nome}]
            this.model.unidadeId = item.unidadeId
            this.model.infraestruturaId = item.id
            this.model.modulos = item.modulos.map(modulo => modulo.id)

            this.$refs.RkmModal.show()
        },
        handleUnidadeChange(value) {
            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            const request = {
                listar: 'infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.parametrizacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.infraestruturas = response.data

                    if (response.data.length === 1) {
                        this.model.infraestruturaId = response.data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            if (this.data.model.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)) {
                this.showValidationNotification('O local de atendimento já foi incluído.')
                return
            }

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                    const infraestrutura = this.data.form.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)

                    this.data.model.infraestruturas.push({
                        unidadeId: unidade.id,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        id: infraestrutura.id,
                        nome: infraestrutura.nome,
                        modulos: this.data.form.modulos.filter(modulo => this.model.modulos.includes(modulo.id))
                    })
                })
        },
        update() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.data.model.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId).modulos = this.data.form.modulos
                        .filter(modulo => this.model.modulos.includes(modulo.id))
                })
        },
        include() {
            if (this.editing === false && this.data.model.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)) {
                this.showValidationNotification('O local de atendimento já foi incluído.')
                return
            }

            if (this.editing) {
                this.update()
            } else {
                this.store()
            }

            this.$refs.RkmModal.hide()
        },
        resetForm() {
            this.data.form.infraestruturas = []
            this.editing = false
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>